import Vue from 'vue'

Vue.directive('click-outside', {
    bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
            // here I check that click was outside the el and his childrens
            // eslint-disable-next-line eqeqeq
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event)
            }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    }
})

const state = new WeakMap()

Vue.directive('loading', {
    bind: el => {
        state.set(el, el.innerHTML)
    },
    update: (el, binding) => {
        if (binding.modifiers.btn) {
            if (binding.value) {
                el.disabled = true
                el.innerHTML = '<i class="fas fa-spinner fa-pulse"></i>'
            } else {
                el.innerHTML = state.get(el)
                el.disabled = false
            }
        }
    },
    unbind: el => {
        state.delete(el)
    }
})
